import { BerlinThemeProvider } from "../theme/ThemeProvider";
import { HelpCenterContainer } from "./HelpCenterContainer";

export function HelpCenterPage() {
  return (
    <BerlinThemeProvider>
      <HelpCenterContainer />
    </BerlinThemeProvider>
  );
}
